import { createSelector } from "reselect";
import get from "lodash/get";
import moment from "moment";

export const checkEligibilityLinesDomain = state =>
  get(state, "api.checkEligibilityLines.data", {});

const eligibilitySettingsDomain = state =>
  get(state, "api.eligibilitySettings.data", {});

const eligiblePlansDomain = state =>
  get(state, "api.eligiblePlans.data[0]", {});

export const orderTerminationStatusDomain = state =>
  get(state, "api.orderTerminationStatus.data", {});

export const orderTerminationDetailDomain = state =>
  get(state, "api.orderTerminationDetails.data", {});

export const checkEligibilityLinesSelector = createSelector(
  checkEligibilityLinesDomain,
  eligibilityLineSettings => eligibilityLineSettings
);

export const eligibilitySettingsSelector = createSelector(
  eligibilitySettingsDomain,
  eligibilitySettings => eligibilitySettings
);

export const simReplacementEligibiliy = createSelector(
  eligibilitySettingsDomain,
  eligibilitySettings => !!eligibilitySettings?.sim_replacement?.eligible
);

export const accountTerminationEligibiliy = createSelector(
  eligibilitySettingsDomain,
  eligibilitySettings => !!eligibilitySettings?.account_termination?.eligible
);

export const cancelAccountTerminationEligibiliy = createSelector(
  eligibilitySettingsDomain,
  eligibilitySettings =>
    !!eligibilitySettings?.cancel_account_termination?.eligible
);

export const terminationIneligibilityReasonSelector = createSelector(
  eligibilitySettingsDomain,
  eligibilitySettings => eligibilitySettings?.account_termination?.meta?.reason
);

export const makeSelectEligibleServices = () =>
  createSelector(
    eligibilitySettingsDomain,
    eligibilitySettings => eligibilitySettings
  );

export const makeSelectEligibleActions = () =>
  createSelector(
    eligibilitySettingsDomain,
    eligibilitySettings => eligibilitySettings
  );

export const makeSelectEligiblePlansServices = () =>
  createSelector(eligiblePlansDomain, eligiblePlans => eligiblePlans);

export const makeSelectTerminationEligibility = () =>
  createSelector(eligibilitySettingsDomain, eligibilitySettings => {
    return get(eligibilitySettings, "account_termination.eligible", false);
  });

export const makeSelectUserOrderEligibility = () =>
  createSelector(eligibilitySettingsDomain, eligibilitySettings => {
    return get(eligibilitySettings, "sim_only_order.eligible", true);
  });

export const eligibilityActionsStatusSelector = createSelector(
  eligibilitySettingsDomain,
  eligibilityActions => {
    return eligibilityActions;
  }
);

export const orderTerminationStatusSelector = createSelector(
  orderTerminationStatusDomain,
  orderStatus => {
    return orderStatus;
  }
);

export const orderTerminationDetailSelector = createSelector(
  orderTerminationDetailDomain,
  orderDetails => {
    return orderDetails;
  }
);

export const orderTerminationCancelEligible = createSelector(
  orderTerminationDetailDomain,
  cancelAccountTerminationEligibiliy,
  (orderDetails, quiltEligibility) => {
    const difference =
      moment(orderDetails?.executeAt).diff(moment(new Date()), "seconds") /
        (60 * 60) >
      24;
    return (
      quiltEligibility && difference && orderDetails?.status === "SCHEDULED"
    );
  }
);

export const makeSelectEligibilitySettings = () => eligibilitySettingsSelector;
export const makeorderTerminationStatusSelector = () =>
  orderTerminationStatusSelector;

export const makeOrderTerminationCancelEligible = () =>
  orderTerminationCancelEligible;

export const makeorderTerminationDetailSelector = () =>
  orderTerminationDetailSelector;

export const makeTerminationIneligibilityReason = () =>
  terminationIneligibilityReasonSelector;

export const makeEligibilityLinesSelector = () => checkEligibilityLinesSelector;
